import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface BolsaHistorico {
  id?: string;
  // Adicione os campos necessários conforme o modelo real
}

@Injectable({
  providedIn: 'root'
})
export class BolsaHistoricoService {
  private readonly path = 'bolsa';

  constructor(private apiService: ApiService) {}

  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: BolsaHistorico[] }>(`getAllBolsaHistorico`, params ? new HttpParams({ fromObject: params }) : undefined).pipe(
      map(response => response)
    );
  }

  show(id: string): Observable<any> {
    return this.apiService.get<{ object: BolsaHistorico }>(`getBolsaHistoricoById/${id}`).pipe(
      map(response => response)
    );
  }

  store(bolsaHistorico: BolsaHistorico): Observable<any> {
    return this.apiService
      .post<{ object: BolsaHistorico }>(`AddBolsaHistorico`, bolsaHistorico)
      .pipe(map(response => response));
  }

  storeRange(historicos: BolsaHistorico[]): Observable<any> {
    return this.apiService
      .post<{ data: BolsaHistorico[] }>(`AddBolsaHistoricoRange`, historicos)
      .pipe(map(response => response));
  }

  update(bolsaHistorico: BolsaHistorico): Observable<any> {
    return this.apiService
      .put<{ object: BolsaHistorico }>(`UpdateBolsaHistorico`, bolsaHistorico)
      .pipe(map(response => response));
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(`DeleteBolsaHistoricoById/${id}`);
  }
}
